import React, { Component } from 'react';
import { Form, Col, Button, Alert } from 'react-bootstrap';
import api from '../utils/api'; // Import your Axios instance
import Notification from '../components/Notification';

class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            appConfig: {
                orgId: "",
                name: "",
                address: "",
                address2: "",
                city: "",
                state: "",
                zip: "",
                phone: "",
                email: "", // Added email field
                taxId: "",
                lastReceiptNumber: "",
                lastManualReceiptNumber: "",
                mailingAddress: "",
                website: "",
                facebookPage: "",
                qrCodeImage: "",
                creditcardPage: "",
                logoImage: ""
            },
            error: null, // Track error state
            notificationMessage: null // Track notification message state
        };
    }

    componentDidMount() {
        this.getAppConfig();
    }

    getAppConfig() {
        api.get('/api/appconfig')
            .then(res => {
                if (res.data.data) {
                    const {
                        orgId,
                        name,
                        address,
                        address2,
                        city,
                        state,
                        zip,
                        phone,
                        email, // Added email field
                        taxId,
                        lastReceiptNumber,
                        lastManualReceiptNumber,
                        mailingAddress,
                        website,
                        facebookPage,
                        qrCodeImage,
                        creditcardPage,
                        logoImage
                    } = res.data.data;

                    this.setState({
                        appConfig: {
                            orgId,
                            name,
                            address,
                            address2,
                            city,
                            state,
                            zip,
                            phone,
                            email, // Added email field
                            taxId,
                            lastReceiptNumber,
                            lastManualReceiptNumber,
                            mailingAddress,
                            website,
                            facebookPage,
                            qrCodeImage,
                            creditcardPage,
                            logoImage
                        },
                        error: null
                    });
                } else {
                    this.setState({ error: res.data.error });
                }
            })
            .catch(error => {
                if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                    console.log('User is not authenticated or token expired. Redirecting to login page.');
                    this.props.history.push('/login');
                } else {
                    if (error.response.status === 404) {
                        console.error('Error fetching organization details:', error);
                        this.setState({ error: 'No organization found. Please contact support.' });
                    } else {
                        console.error('Error fetching organization app config:', error);
                        this.setState({ error: 'Failed to fetch organization application configuration.' });
                    }
                }
            });
    }

    handleFormSubmit = (event) => {
        event.preventDefault();

        const {
            orgId,
            name,
            address,
            address2,
            city,
            state,
            zip,
            phone,
            email, // Added email field
            taxId,
            lastReceiptNumber,
            lastManualReceiptNumber,
            mailingAddress,
            website,
            facebookPage,
            qrCodeImage,
            creditcardPage,
            logoImage
        } = this.state.appConfig;

        api.put('/api/appconfig', {
            orgId,
            name,
            address,
            address2,
            city,
            state,
            zip,
            phone,
            email, // Added email field
            taxId,
            lastReceiptNumber,
            lastManualReceiptNumber,
            mailingAddress,
            website,
            facebookPage,
            qrCodeImage,
            creditcardPage,
            logoImage
        })
            .then(res => {
                if (res.data.msg) {
                    console.log('Success:', res.data.msg);
                    this.setState({ notificationMessage: res.data.msg, error: null }); // Set notification message
                } else {
                    console.log('API Update Issue:', res.data.error);
                    this.setState({ error: res.data.error, notificationMessage: null }); // Handle other errors
                }
            })
            .catch(error => {
                console.error('Error updating app config:', error);
                this.setState({ error: 'Failed to update application configuration.', notificationMessage: null });
            });
    }

    handleCancel = () => {
        this.props.history.push('/'); // Navigate to homepage
    }

    render() {
        const {
            name,
            address,
            address2,
            city,
            state,
            zip,
            phone,
            email, // Added email field
            taxId,
            lastReceiptNumber,
            lastManualReceiptNumber,
            mailingAddress,
            website,
            facebookPage,
            qrCodeImage,
            creditcardPage,
            logoImage
        } = this.state.appConfig;

        const { error, notificationMessage } = this.state;

        return (
            <div className="container p-3 mb-5 bg-white rounded">
                {error && <Alert variant="danger">{error}</Alert>} {/* Display error if exists */}
                {notificationMessage && <Notification message={notificationMessage} />} {/* Display notification if exists */}
                <h4>Complete the form and press SUBMIT to save</h4>
                <Form onSubmit={this.handleFormSubmit}>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>Organization Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter Organization Name"
                                defaultValue={name}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, name: e.target.value } })}
                            />
                        </Form.Group>
                    </Form.Row>

                    <Form.Group controlId="formGridAddress1">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                            placeholder="1234 Main St"
                            defaultValue={address}
                            onChange={e => this.setState({ appConfig: { ...this.state.appConfig, address: e.target.value } })}
                        />
                    </Form.Group>

                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridAddress2">
                            <Form.Label>Address 2</Form.Label>
                            <Form.Control
                                placeholder="Apartment, studio, or floor"
                                defaultValue={address2}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, address2: e.target.value } })}
                            />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridMailingAddress">
                            <Form.Label>Mailing Address</Form.Label>
                            <Form.Control
                                placeholder="Mailing Address"
                                defaultValue={mailingAddress}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, mailingAddress: e.target.value } })}
                            />
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridPhone">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                                placeholder="Phone Number"
                                defaultValue={phone}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, phone: e.target.value } })}
                            />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Email Address"
                                defaultValue={email}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, email: e.target.value } })}
                            />
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridCity">
                            <Form.Label>City</Form.Label>
                            <Form.Control
                                defaultValue={city}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, city: e.target.value } })}
                            />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridState">
                            <Form.Label>State</Form.Label>
                            <Form.Control
                                defaultValue={state}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, state: e.target.value } })}
                            />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridZip">
                            <Form.Label>Zip</Form.Label>
                            <Form.Control
                                defaultValue={zip}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, zip: e.target.value } })}
                            />
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridLastReceiptNumber">
                            <Form.Label>Last Receipt Number</Form.Label>
                            <Form.Control
                                defaultValue={lastReceiptNumber}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, lastReceiptNumber: e.target.value } })}
                            />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridLastManualReceiptNumber">
                            <Form.Label>Last Manual Receipt Number</Form.Label>
                            <Form.Control
                                defaultValue={lastManualReceiptNumber}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, lastManualReceiptNumber: e.target.value } })}
                            />
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridWebsite">
                            <Form.Label>Website</Form.Label>
                            <Form.Control
                                placeholder="Website URL"
                                defaultValue={website}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, website: e.target.value } })}
                            />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridFacebookPage">
                            <Form.Label>Facebook Page</Form.Label>
                            <Form.Control
                                placeholder="Facebook Page URL"
                                defaultValue={facebookPage}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, facebookPage: e.target.value } })}
                            />
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridQrCodeImage">
                            <Form.Label>QR Code Image Path</Form.Label>
                            <Form.Control
                                placeholder="QR Code Image Path"
                                defaultValue={qrCodeImage}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, qrCodeImage: e.target.value } })}
                            />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridCreditCardPage">
                            <Form.Label>Credit Card Page URL</Form.Label>
                            <Form.Control
                                placeholder="Credit Card Page URL"
                                defaultValue={creditcardPage}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, creditcardPage: e.target.value } })}
                            />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridLogoImage">
                            <Form.Label>Logo Image Path</Form.Label>
                            <Form.Control
                                placeholder="Logo Image Path"
                                defaultValue={logoImage}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, logoImage: e.target.value } })}
                            />
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridTaxId">
                            <Form.Label>Tax ID</Form.Label>
                            <Form.Control
                                placeholder="Tax ID"
                                defaultValue={taxId}
                                onChange={e => this.setState({ appConfig: { ...this.state.appConfig, taxId: e.target.value } })}
                            />
                        </Form.Group>
                    </Form.Row>

                    <Button variant="primary" className="m-2" type="submit">
                        Submit
                    </Button>
                    <Button variant="secondary" type="button" onClick={this.handleCancel}>
                        Cancel
                    </Button>
                </Form>
            </div>
        );
    }
}

export default Settings;